import * as i0 from "@angular/core";
/**
 * Service to manage the expansion of folders in the folder tree.
 *
 * Used to keep track of which folders are expanded in the folder tree.
 * It should be injected in the ancestor component of a folder tree.
 */
export class FolderExpansionService {
    get foldersValue() {
        return this.folders;
    }
    constructor() {
        this.folders = {};
    }
    getCssClasses(item) {
        const cssClasses = {
            collapse: true,
            show: true,
        };
        const { viewDepth } = item;
        if (viewDepth && viewDepth > 0) {
            // View depth on the frontend is zero-based, so subtract by 1.
            cssClasses[`level-${viewDepth - 1}`] = true;
        }
        return cssClasses;
    }
    getId(item) {
        return `collapse${item.viewDepth}`;
    }
    isExpanded(folderId) {
        return folderId in this.folders && this.folders[folderId].expanded;
    }
    /**
     * Toggle a folder between collapsed or expanded states.
     */
    toggle(folderId, ancestorId) {
        if (this.isExpanded(folderId)) {
            this.collapse(folderId);
        }
        else {
            this.expand(folderId, ancestorId);
        }
    }
    /**
     * Collapse a folder and all of its descendant folders.
     */
    collapse(folderId) {
        const _folders = [[this.folders[folderId], folderId]];
        while (_folders.length > 0) {
            const [_folder, _folderId] = _folders.shift();
            // Validate folder
            // We do not expect this error to occur.
            // This is a safeguard against invalid mappings.
            if (!_folder || !(_folderId in this.folders)) {
                throw Error(`Invalid folderId = ${folderId}.`);
            }
            // Mark folder as collapsed
            this.folders[_folderId].expanded = false;
            // Add folder descendants that need to be collapsed as well.
            this.folders[_folderId].descendants.forEach((_id) => {
                _folders.push([this.folders[_id], _id]);
            });
        }
    }
    /**
     * Expand a folder.
     * - Descendant folders are not affected.
     */
    expand(folderId, ancestorId) {
        // Validate and update ancestors
        if (ancestorId !== null && ancestorId in this.folders) {
            this.folders[ancestorId].descendants.push(folderId);
        }
        // Expanding folder for the first time: Add the folder to the `folders` mapping.
        if (!(folderId in this.folders)) {
            this.folders[folderId] = {
                expanded: true,
                descendants: [],
            };
        }
        else {
            // This is not the first time the folder is expanded. We can assume it is already in the mapping.
            this.folders[folderId].expanded = true;
        }
    }
}
FolderExpansionService.ɵfac = function FolderExpansionService_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || FolderExpansionService)(); };
FolderExpansionService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: FolderExpansionService, factory: FolderExpansionService.ɵfac });
